{
  "blocks": [
    {
      "id": "module-pgt-a",
      "kind": "module",
      "tags": ["both-partners", "testing", "genetic-screening"],
      "title": "PGT-A Screening",
      "subtitle": "Preimplantation genetic testing for chromosomal abnormalities",
      "icon": "🧪",
      "body": {
        "duration": "7–10 days",
        "category": "testing",
        "forWhom": "both",
        "includes": [
          "Trophectoderm biopsy of blastocyst-stage embryos",
          "Next-generation sequencing for all 23 chromosome pairs",
          "Euploid / aneuploid / mosaic classification per embryo",
          "Results report with transfer recommendations",
          "Genetic counselor consultation to review findings"
        ],
        "priceRange": {
          "low": 3000,
          "high": 6000
        },
        "currency": "USD",
        "status": "coming-soon",
        "steps": [
          {
            "title": "Biopsy",
            "description": "A few cells are taken from the outer layer (trophectoderm) of each blastocyst. Embryos are frozen during testing."
          },
          {
            "title": "Genetic analysis",
            "description": "Samples are sent to a genetics lab. Results typically take 7–10 business days."
          },
          {
            "title": "Results review",
            "description": "Each embryo classified as euploid (normal chromosomes), aneuploid, or mosaic. Guides transfer decisions."
          }
        ]
      },
      "sources": [
        {
          "title": "Preimplantation genetic testing for aneuploidy: a practice committee opinion",
          "journal": "Fertility and Sterility",
          "year": 2022,
          "evidenceLevel": "expert-opinion"
        }
      ]
    }
  ],
  "relationships": [],
  "localeVariants": []
}
